var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app-bar',{attrs:{"color":"pink darken-4","dense":"","dark":"","fixed":""}},[_c('v-btn',{attrs:{"icon":"","to":"/"}},[_c('v-icon',[_vm._v("mdi-home")])],1),_c('v-toolbar-title',[_vm._v("Petition Data for petition ID: "+_vm._s(_vm.petition_id))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }